export const toReadableUrl = (text) => {
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
};
